document.addEventListener('DOMContentLoaded', function() {
    const cards = document.querySelectorAll('.content');

    cards.forEach(card => {
        const ribbons = card.getElementsByClassName('ribbon');

        if (ribbons.length >= 2) {
            const ribbonWidth1 = ribbons[1].offsetWidth;
            ribbons[0].style.right = `${ribbonWidth1 + 30}px`;
        }

        if (ribbons.length >= 3) {
            const ribbonWidth1 = ribbons[1].offsetWidth;
            const ribbonWidth2 = ribbons[2].offsetWidth;
            ribbons[0].style.right = `${ribbonWidth1 + ribbonWidth2 + 36}px`;
            ribbons[1].style.right = `${ribbonWidth2 + 30}px`;
        }
    });
});
